import React from 'react'
import { Text } from '@chakra-ui/react'

const NoComments = () => {
  return (
    <Text
      textStyle="tinyHeader"
      color="brand.textGray"
      mt="8px"
      borderRadius="5px"
      backgroundColor="rgba(0, 0, 0, .03)"
      p="12px 40px"
      fontStyle="italic"
      textAlign="center"
    >
      Click on the "+" button to add a new comment.
    </Text>
  )
}

NoComments.propTypes = {}

export default NoComments
